import { useFxWorkspaceContext } from '@mobile-mapping/providers';
import { BtnClasses, Button } from '@tcweb/connect-ui';
import { t } from '@trimble/i18n';
import type { JSX } from 'solid-js';

import { FxWorkspaceEmptyState } from './FxWorkspaceEmptyState';

export const WorkspaceEmptyReferences = (): JSX.Element => {
  const fxWorkspace = useFxWorkspaceContext();

  return (
    <FxWorkspaceEmptyState
      icon="tc-icon-folder"
      title={t('mobileMapping.fxWorkspace.emptyWorkspace.title')}
      message={t('mobileMapping.fxWorkspace.emptyWorkspace.message')}
      dataTestId="workspace-empty-references"
      content={
        <Button
          color={BtnClasses.PRIMARY}
          icon="tc-icon-content-add"
          data-testid="workspace-add-data-button"
          onClick={() => fxWorkspace.enterWorkspaceDataEditing()}
        >
          {t('mobileMapping.fxWorkspace.addData')}
        </Button>
      }
    />
  );
};
